import React from 'react'
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs'
import WrapperSection from '../../components/global/WrapperSection'
import FormAddEditUsers from '../../components/Users/FormAddEditUsers'

const CreateUsers = () => {
  return (
    <>
      <WrapperSection>
        <GlobalBreadcrumbs />
        <FormAddEditUsers />
      </WrapperSection>
    </>
  )
}

export default CreateUsers